/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { queryOptions, useQuery, useSuspenseQuery } from '@tanstack/react-query'
import type {
	UseQueryOptions,
	UseQueryResult,
	UseSuspenseQueryOptions,
	UseSuspenseQueryResult,
} from '@tanstack/react-query'
import type { AxiosError, AxiosRequestConfig } from 'axios'
import { planIndex } from '../../axios/planIndex'
import type {
	PlanIndexError,
	PlanIndexPathParams,
	PlanIndexQueryParams,
	PlanIndexResponse,
} from '../../types/PlanIndex'

export const planIndexQueryKey = (organisation: PlanIndexPathParams['organisation'], params?: PlanIndexQueryParams) =>
	[{ url: '/:organisation/plans', params: { organisation } }, ...(params ? [params] : [])] as const

export type PlanIndexQueryKey = ReturnType<typeof planIndexQueryKey>

/** @see backend/nexus/modules/Billing/Http/Controllers/PlanController.php PlanController::index */
export function planIndexQueryOptions(
	organisation: PlanIndexPathParams['organisation'],
	params?: PlanIndexQueryParams,
	config?: AxiosRequestConfig,
) {
	return queryOptions<PlanIndexResponse, AxiosError<PlanIndexError>, PlanIndexResponse, PlanIndexQueryKey>({
		queryKey: planIndexQueryKey(organisation, params),
		queryFn: ({ signal }) => planIndex(organisation, params, { signal, ...config }).then(res => res.data),
		enabled: !!organisation,
	})
}

/** @see backend/nexus/modules/Billing/Http/Controllers/PlanController.php PlanController::index */
export function usePlanIndex<TSelectData = PlanIndexResponse>(
	organisation: PlanIndexPathParams['organisation'],
	params?: PlanIndexQueryParams,
	options?:
		& Partial<
			Omit<
				UseQueryOptions<PlanIndexResponse, AxiosError<PlanIndexError>, TSelectData, PlanIndexQueryKey>,
				'queryKey' | 'queryFn'
			>
		>
		& { queryKey?: readonly unknown[] },
): UseQueryResult<TSelectData, AxiosError<PlanIndexError>> {
	const { queryKey: customQueryKey, ...opts } = options ?? {}
	return useQuery({
		...planIndexQueryOptions(organisation, params),
		...opts as any,
		...(customQueryKey ? { queryKey: customQueryKey as any } : {}),
	})
}

/** @see backend/nexus/modules/Billing/Http/Controllers/PlanController.php PlanController::index */
export function usePlanIndexSuspense<TSelectData = PlanIndexResponse>(
	organisation: PlanIndexPathParams['organisation'],
	params?: PlanIndexQueryParams,
	options?:
		& Partial<
			Omit<
				UseSuspenseQueryOptions<PlanIndexResponse, AxiosError<PlanIndexError>, TSelectData, PlanIndexQueryKey>,
				'queryKey' | 'queryFn'
			>
		>
		& { queryKey?: readonly unknown[] },
): UseSuspenseQueryResult<TSelectData, AxiosError<PlanIndexError>> {
	const { queryKey: customQueryKey, ...opts } = options ?? {}
	return useSuspenseQuery({
		...planIndexQueryOptions(organisation, params),
		...opts as any,
		...(customQueryKey ? { queryKey: customQueryKey as any } : {}),
	})
}
